/**
 * Splits a string into a numeric value and a unit.
 *
 * @param value - The input string to be split. It should be in the format of a number
 *                optionally followed by a unit (e.g., "123.45kg", "100", "50.5m").
 * @returns An object containing:
 *          - value: The numeric part of the input as a string, or the original input if invalid.
 *          - unit: The unit part of the input as a string, or null if no unit is present or input is invalid.
 *
 * @example
 * splitValueAndUnit("123.45kg") // returns { value: "123.45", unit: "kg" }
 * splitValueAndUnit("100") // returns { value: "100", unit: null }
 * splitValueAndUnit("invalid") // returns { value: "invalid", unit: null }
 */
export const splitValueAndUnit = (value?: string | null) => {
  const regex = /^(\d*(\.\d+)?)([a-zA-Z]*)$/
  if (value == null || !regex.test(value)) return { value, unit: null }
  const match = value.match(regex)
  return {
    value: match?.[1],
    unit: match?.[3] ?? null
  }
}
